import { uniqueId } from 'lodash';

import { KeyCode } from '../../typings/common';

class KeyDownManager {
    private storage: Map<string, { handlers: Map<KeyCode, () => void>; isTurnedOn: boolean }>;

    constructor() {
        this.storage = new Map();
    }

    on(handlers: [KeyCode, () => void][], isTurnedOn: boolean = true): string {
        const id = uniqueId('keyDownManager_');

        if (!this.storage.size) {
            window.addEventListener('keydown', this.onWindowKeyDown);
        }

        this.storage.set(id, {
            handlers: new Map(handlers),
            isTurnedOn
        });

        return id;
    }

    off(id: string): void {
        this.storage.delete(id);

        if (!this.storage.size) {
            window.removeEventListener('keydown', this.onWindowKeyDown);
        }
    }

    turn(id: string, isTurnedOn: boolean): void {
        const item = this.storage.get(id);

        if (item) {
            item.isTurnedOn = isTurnedOn;
        }
    }

    private onWindowKeyDown = (e: KeyboardEvent): void => {
        const keyCode = e.keyCode;
        const reverseList = Array.from(this.storage.values()).reverse();
        const { handlers }: { handlers?: Map<KeyCode, () => void> } = reverseList.find(item => item.isTurnedOn) || {};

        if (handlers) {
            const callback = handlers.get(keyCode);

            if (callback) {
                callback();
            }
        }
    };
}

export const keyDownManager = new KeyDownManager();
